<template>
  <v-form ref="mainForm" v-model="valid">
    <data-iterator
      :list="sas.stagesInternats"
      add-new-text="Ajouter un stage"
      :live="{ endpoint: 'sas-equivalence-stages-internats', sasId: sas.id, payload: { codeTypePratique: '1' } }"
      optional
      card-width="900"
      :icon="$getIcon('formationPratique')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{}">
        <h3>Stage</h3>
      </template>
      <template v-slot:edit-mode="{ item }">
        <opq-file code="stage-attestation" :live="liveSasStagesInternats(7126, item)" :file="item.attestationStage"></opq-file>
        <opq-file code="stage-superviseur" :live="liveSasStagesInternats(7127, item)" :file="item.identificationSuperviseurStage"></opq-file>
        <opq-file code="stage-rapport" :live="liveSasStagesInternats(7128, item)" :file="item.rapportEvaluationStage"></opq-file>
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import FormHybrid from "@/mixins/FormHybrid"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormHybrid, CataloguesHelper],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasStagesInternats(cle, item) {
      return { endpoint: "sas-equivalence-stages-internats", cle: cle, fileId: item.id }
    }
  }
}
</script>

<style>
</style>